import { v4 as uuid } from 'uuid';
import { USER_DIALOG_ACTION_TYPES } from '../../constants/userDialog.constants';

export const showZoneDialog = ({ requestId = uuid(), ...options } = {}) => ({
  type: USER_DIALOG_ACTION_TYPES.SHOW_ZONE_DIALOG,
  payload: { ...options, requestId },
});

export const hideZoneDialog = (requestId) => ({
  type: USER_DIALOG_ACTION_TYPES.HIDE_ZONE_DIALOG,
  payload: { requestId },
});

export const zoneDialogSaved = (zone, requestId) => ({
  type: USER_DIALOG_ACTION_TYPES.ZONE_DIALOG_SAVED,
  payload: { zone, requestId },
});
